(() => {
  const init = root => {
    if (root.dataset.initialized) return;
    const form = root.querySelector('form');
    if (!form) return;
    root.dataset.initialized = 'true';
    const one = s => root.querySelector(s);
    const panels = [...root.querySelectorAll('[data-panel]')];
    const labels = ['Your child', 'Their photo', 'Santa’s secret', 'Review'];
    const types = {
      achievement: ['A proud moment', 'learned to ride a bike', 'For example: “learned to ride a bike.”'],
      school_creation: ['Something they made', 'a cardboard rocket at school', 'For example: “a cardboard rocket at school.”'],
      pet: ['Their pet', 'their dog Biscuit', 'Include the pet’s name and kind, such as “their dog Biscuit.”'],
      favorite: ['A favourite thing', 'dinosaurs and drawing', 'For example: “dinosaurs and drawing.”']
    };
    let step = 0, busy = false, photoURL = '';
    const checks = new Map();
    const error = message => { one('[data-error]').textContent = message; one('[data-error]').hidden = !message; };
    const value = selector => one(selector).value.trim();
    function review() {
      one('[data-review-child]').textContent = `${value('[data-name]')}, age ${value('[data-age]')}${value('[data-pronunciation]') ? ' · Pronounced ' + value('[data-pronunciation]') : ''}`;
      const type = root.querySelector('input[type=radio]:checked')?.value;
      one('[data-review-secret]').textContent = `${types[type]?.[0] || ''}: ${value('[data-detail]')}`;
      one('[data-review-filename]').textContent = one('[data-photo]').files[0]?.name || '';
      const image = one('[data-review-photo]');
      image.hidden = !photoURL;
      if (photoURL) image.src = photoURL; else image.removeAttribute('src');
    }
    function go(index, focus = true) {
      step = index;
      panels.forEach((p, i) => p.hidden = i !== index);
      one('[data-step-label]').textContent = `Step ${index + 1} of 4 · ${labels[index]}`;
      const progress = one('[role=progressbar]');
      progress.setAttribute('aria-valuenow', index + 1);
      [...progress.children].forEach((bar, i) => bar.classList.toggle('is-done', i <= index));
      one('[data-next]').hidden = index === 3;
      one('[data-back]').hidden = index === 0;
      one('[data-secret-intro]').textContent = `What would make ${value('[data-name]') || 'your child'} smile if Santa mentioned it?`;
      error('');
      if (index === 3) review();
      if (focus) panels[index].querySelector('h1').focus({preventScroll: false});
    }
    function valid(index) {
      for (const input of panels[index].querySelectorAll('input,select,textarea')) {
        if (input.type === 'text' || (!input.type && input.tagName === 'INPUT')) input.value = input.value.trim();
        if (checks.get(input) === 'pending') { error('Please wait while we check the photo.'); return false; }
        if (!input.checkValidity()) { go(index); input.reportValidity(); return false; }
      }
      return true;
    }
    function next() { if (valid(step)) go(Math.min(3, step + 1)); }
    function checkPhoto(input) {
      input.setCustomValidity('');
      const primary = input.matches('[data-photo]');
      if (primary) {
        if (photoURL) URL.revokeObjectURL(photoURL);
        photoURL = ''; one('[data-photo-preview]').hidden = true;
      }
      const file = input.files[0];
      if (!file) { checks.delete(input); return; }
      let message = '';
      if (!['image/jpeg', 'image/png', 'image/webp'].includes(file.type)) message = 'Please choose a JPG, PNG or WebP photo.';
      if (file.size > 15 * 1024 * 1024) message = 'Please choose a photo smaller than 15 MB.';
      if (message) { input.setCustomValidity(message); checks.set(input, 'invalid'); error(message); return; }
      checks.set(input, 'pending');
      const url = URL.createObjectURL(file), image = new Image();
      image.onload = () => {
        if (input.files[0] !== file) { URL.revokeObjectURL(url); return; }
        checks.set(input, 'valid'); error('');
        if (primary) {
          photoURL = url;
          const preview = one('[data-photo-preview]');
          preview.querySelector('img').src = url;
          preview.querySelector('span').textContent = file.name;
          preview.hidden = false;
        } else URL.revokeObjectURL(url);
      };
      image.onerror = () => {
        URL.revokeObjectURL(url);
        if (input.files[0] !== file) return;
        checks.set(input, 'invalid');
        input.setCustomValidity('We couldn’t open this photo. Please choose another JPG, PNG or WebP image.');
        error(input.validationMessage);
      };
      image.src = url;
    }
    root.querySelectorAll('input[type=file]').forEach(input => input.addEventListener('change', () => checkPhoto(input)));
    root.querySelectorAll('input[type=radio]').forEach(input => input.addEventListener('change', () => {
      const chosen = types[input.value];
      one('[data-detail]').placeholder = 'e.g. ' + chosen[1];
      one('[data-example]').textContent = chosen[2];
    }));
    one('[data-next]').addEventListener('click', next);
    one('[data-back]').addEventListener('click', () => go(Math.max(0, step - 1)));
    root.querySelectorAll('[data-edit]').forEach(button => button.addEventListener('click', () => go(Number(button.dataset.edit))));
    form.noValidate = true;
    form.addEventListener('submit', event => {
      if (busy) { event.preventDefault(); return; }
      if (step < 3) { event.preventDefault(); next(); return; }
      for (let i = 0; i < 3; i++) if (!valid(i)) { event.preventDefault(); return; }
      if (root.dataset.preview === 'true') {
        event.preventDefault(); error('Preview complete. On Shopify, this sends the photo and details to checkout.'); return;
      }
      // Native multipart POST preserves file properties and Shopify's redirect.
      busy = true;
      one('[data-checkout]').disabled = true;
      one('[data-checkout]').textContent = 'Opening checkout…';
    });
    window.addEventListener('pageshow', () => {
      busy = false; one('[data-checkout]').disabled = false;
      one('[data-checkout]').textContent = 'Continue to checkout →';
    });
    one('[data-controls]').hidden = false;
    root.classList.add('is-ready');
    go(0, false);
  };
  const boot = scope => scope.querySelectorAll('[data-lsg-questionnaire]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document)); else boot(document);
  if (!window.lsgQuestionnaireEditorListener) {
    document.addEventListener('shopify:section:load', event => boot(event.target));
    window.lsgQuestionnaireEditorListener = true;
  }
})();